import { ReactNode } from 'react'
import { notFound } from 'next/navigation'
import { useUserContext } from '~/src/providers/user-provider'
import { FEATURE_FLAGS, displayFeature } from './feature-flags'

interface FeatureFlagRouteProps {
  featureFlag: FEATURE_FLAGS
  children: ReactNode
  redirect?: boolean
}

export function FeatureFlagRoute({ featureFlag, children, redirect = true }: FeatureFlagRouteProps) {
  const { user } = useUserContext()

  const isFeatureEnabled = displayFeature(featureFlag, user)

  if (!redirect && !isFeatureEnabled) {
    return <></>
  }

  if (!isFeatureEnabled) {
    notFound()
  }

  return <>{children}</>
}
